module.exports = __webpack_public_path__ + "static/media/Bahamas yacht charter.e9e66134.jpg";